import { render, staticRenderFns } from "./Fdc.vue?vue&type=template&id=2efd9a50&scoped=true"
import script from "./Fdc.vue?vue&type=script&lang=js"
export * from "./Fdc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd9a50",
  null
  
)

export default component.exports